"use client";

import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  type CaloriesCalculatorFormType,
  caloriesCalculatorSchema,
} from "../schemas/calories-calculator-schema";
import { calculateDailyCalories } from "../utils/calculate-daily-calories";

const defaultValues = {
  gender: "female",
  goal: undefined,
  activityLevel: undefined,
  height: "",
  weight: "",
  age: "",
} as unknown as CaloriesCalculatorFormType;

export const useCaloriesCalculator = (isOpen: boolean) => {
  const [result, setResult] = useState<number | null>(null);

  const form = useForm<CaloriesCalculatorFormType>({
    defaultValues,
    resolver: zodResolver(caloriesCalculatorSchema),
  });

  const { reset } = form;

  useEffect(() => {
    if (isOpen) {
      reset(defaultValues);
      setResult(null);
    }
  }, [isOpen, reset]);

  const onSubmit = form.handleSubmit((values) => {
    setResult(
      calculateDailyCalories({
        activityLevel: values.activityLevel,
        age: Number.parseInt(values.age, 10),
        gender: values.gender,
        goal: values.goal,
        height: Number.parseInt(values.height, 10),
        weight: Number.parseInt(values.weight, 10),
      }),
    );
  });

  const onRecalculate = () => {
    reset(defaultValues);
    setResult(null);
  };

  return { form, onRecalculate, onSubmit, result };
};
